import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NotifyService } from '../../services/notify.service';
import { AlertsService } from '../../services/alerts.service';
import { HomeService } from '../../services/home.service';
import { MatDialog } from '@angular/material/dialog';
import { CloseAlertComponent } from '../../stores/alerts-notify/close-alert/close-alert.component';
import { timestampFormat } from '../../../config/moment';
import { filterRecentNotifications } from '../../../config/moment';

@Component({
  selector: 'app-notification-dropdown',
  templateUrl: './notification-dropdown.component.html',
  styleUrls: ['./notification-dropdown.component.scss']
})
export class NotificationDropdownComponent implements OnInit {
  @Input() isOpen: boolean = false;
  @Output() toggleDropdown = new EventEmitter<void>();

  public notify: any = [];
  public alerts: any = [];
  public closedAlertIds: number[] = [];
  public timestampFormat = timestampFormat;
  public filterRecentNotifications = filterRecentNotifications;
  public unreadCount: number = 0;

  constructor(
    private notifyService: NotifyService,
    private alertsService: AlertsService,
    private homeService: HomeService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadNotifications();
    this.loadAlerts();
    this.retrieveClosedAlertIds();
  }

  loadNotifications() {
    this.notifyService.getnotify().subscribe((res) => {
      if (res.data) {
        this.notify = this.filterRecentNotifications(res.data.data).slice(0, 5); // Show only latest 5
        this.updateUnreadCount();
      }
    });
  }

  loadAlerts() {
    this.alertsService.getalerts().subscribe((res) => {
      if (res.data) {
        this.alerts = res.data.data
          .filter((alert: any) => !this.closedAlertIds.includes(alert.id))
          .slice(0, 5); // Show only latest 5
        this.updateUnreadCount();
      }
    });
  }

  retrieveClosedAlertIds() {
    this.closedAlertIds = JSON.parse(localStorage.getItem('closedAlertIds') || '[]');
  }

  updateUnreadCount() {
    this.unreadCount = this.alerts.length + this.notify.length;
  }

  onToggleDropdown() {
    this.toggleDropdown.emit();
  }

  openDialog(alert: any): void {
    const dialogRef = this.dialog.open(CloseAlertComponent, {
      data: {
        cabinet_name: alert.cabinet_name,
        product_name: alert.product_name,
        status: alert.status,
        count: alert.count,
        id: alert.id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.closeAlert(alert);
      }
    });
  }

  closeAlert(alert: any): void {
    this.homeService.closeAlert(alert.id).subscribe((res) => {
      if (res.success) {
        const index = this.alerts.indexOf(alert);
        if (index !== -1) {
          this.alerts.splice(index, 1);
          this.closedAlertIds.push(alert.id);
          localStorage.setItem('closedAlertIds', JSON.stringify(this.closedAlertIds));
          this.updateUnreadCount();
        }
      }
    });
  }

  navigateToAlertList() {
    this.router.navigate(['/home/notify/alert']);
    this.onToggleDropdown();
  }

  navigateToNotifyList() {
    this.router.navigate(['/home/notify/list']);
    this.onToggleDropdown();
  }

  navigateToCabinet(cabinetId: number) {
    this.router.navigate(['/home/stocks/cabinets', cabinetId]);
    this.onToggleDropdown();
  }

  navigateToProduct(cabinetId: number) {
    this.router.navigate(['/home/stocks/products', cabinetId]);
    this.onToggleDropdown();
  }
} 